import axiosInstance from "./axiosInstance";

// Fetch timesheet with optional filters (customer, project, month, year, etc.)
export const fetchGetTimeSheet = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("GetTimesheet", {
      params: filters ?? undefined,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Timesheet:", error);
    throw error;
  }
};

// Fetch all customers
export const fetchCustomers = async () => {
  try {
    const response = await axiosInstance.get("/Customers");
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

// Fetch timesheet details by ID
export const getTimeSheetDetailsById = async (id: number): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/GetTimesheetDetailsById?timesheetId=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching timesheet details by ID:", error);
    throw error;
  }
};

export const CreateEmployee = async (formData: any) => {
  try {
    const response = await axiosInstance.post("/CreateEmployee", formData);
    console.log(formData)
    return response;
  } catch (error: any) {
    if (error.response) {
      console.error("API error:", error.response.data);
    } else if (error.request) {
      console.error("No response from server:", error.request);
    } else {
      console.error("Request setup error:", error.message);
    }
    throw error;
  }
};

// Fetch employee burnt hours (summary)
export const fetchEmployeeBurntHours = async () => {
  try {
    const response = await axiosInstance.get("/employee-burnt-hours");
    return response.data;
  } catch (error) {
    console.error("Error fetching employee burnt hours:", error);
    throw error;
  }
};

// Fetch all projects
export const fetchProjects = async () => {
  try {
    const response = await axiosInstance.get("/Projects");
    return response.data;
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

export const UpdateTimesheet = async (
  id: number,
  data: any
) => {
  try {
    const response = await axiosInstance.put(`/UpdateTimesheet/${id}`, data);
        console.log("hi"+id,data)
    console.log("vj"+JSON.stringify(response))
    return response.data;
  } catch (error) {
    console.error("Error updating timesheet:", error);
    throw error;
  }
};




// Fetch available months for filters
export const fetchGetMonths = async () => {
  try {
    const response = await axiosInstance.get("/GetMonths");
    return response.data;
  } catch (error) {
    console.error("Error fetching months:", error);
    throw error;
  }
};

export const deleteTimesheetById = (id: number) => {
  return axiosInstance.delete(`/Timesheet/${id}`);
};



// Fetch available years for filters
export const fetchGetYears = async () => {
  try {
    const response = await axiosInstance.get("/GetYears");
    return response.data;
  } catch (error) {
    console.error("Error fetching years:", error);
    throw error;
  }
};



export const CreateTimesheet = async (payload: any) => {
  try {
    const response = await axiosInstance.post("/CreateTimesheet", payload);
    return response;
  } catch (error: any) {
    // error handling code
    throw error;
  }
};


export const getCustomer = async () => {
  try {
    const response = await axiosInstance.get("/customers");
    return response.data;
  } catch (error) {
    console.error("Error fetching customer list:", error);
    throw error;
  }
};

export const GetNewTimesheetDetails = async (
  month: string,
  year: string,
  customerId: number
): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/timesheet/details`, {
      params: {
        month,
        year,
        customerId,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching timesheet details:", error);
    throw error;
  }
};

export const GetProjectByCustomerId = async (customerId: number) => {
  try {
    const response = await axiosInstance.get("/GetProjectByCustomerId", {
      params: { customerId },
    });
    return response;
  } catch (error) {
    console.error(`Error fetching projects for customer ${customerId}:`, error);
    throw error;
  }
};